import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends BaseComponent implements OnInit {

  ngOnInit(): void {
    this.app.spinner.show();
    this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
    this.app.storageService.removeItem(AppConstants.Customer);
    this.app.storageService.removeItem(AppConstants.Token);
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.storageService.removeItem(AppConstants.RedirectState);
    this.app.storageService.removeItem(AppConstants.PendingTransaction);
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
    this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
    this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
    this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);  
    
    this.app.basketItems = [];
    this.app.reCompute();

    this.app.customer = null;
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
    this.app.spinner.hide();
  }

}
